import { render, staticRenderFns } from "./OcojoImageFinder.vue?vue&type=template&id=edc07c62&scoped=true&"
import script from "./OcojoImageFinder.vue?vue&type=script&lang=ts&"
export * from "./OcojoImageFinder.vue?vue&type=script&lang=ts&"
import style0 from "./OcojoImageFinder.vue?vue&type=style&index=0&id=edc07c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc07c62",
  null
  
)

export default component.exports